export default "__VITE_ASSET__gsO74heg__"